import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import SEOPage from "./Pages/Seo";
import WebDevelopment from "./Pages/WebDevelopmen";
import AppDevelopment from "./Pages/AppDevelopment";
import Cloud from "./Pages/Cloud";
import DigitalMarketing from "./Pages/Digital";
import { useEffect } from "react";

function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scroll(0, 0);
  }, [pathname]);
  return (
    <>
      <Routes>
        <Route path="/shoyeb/" element={<Home />} />
        <Route path="/shoyeb/seo" element={<SEOPage />} />
        <Route path="/shoyeb/web" element={<WebDevelopment />} />
        <Route path="/shoyeb/app" element={<AppDevelopment />} />
        <Route path="/shoyeb/cloud" element={<Cloud />} />
        <Route path="/shoyeb/digital" element={<DigitalMarketing />} />
      </Routes>
    </>
  );
}

export default App;
